var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5527 1.0249C16.4188 0.612911 16.0348 0.333984 15.6016 0.333984C15.1684 0.333984 14.7845 0.612911 14.6506 1.0249L11.6252 10.334H1.60164C1.16339 10.334 0.776197 10.6193 0.64646 11.038C0.516722 11.4566 0.67467 11.9109 1.03611 12.1587L9.16225 17.7309L6.02915 27.0142C5.89001 27.4264 6.0334 27.8813 6.38377 28.1393C6.73415 28.3972 7.2111 28.399 7.56341 28.1437L15.6016 22.3189L23.6399 28.1437C23.9922 28.399 24.4691 28.3972 24.8195 28.1393C25.1699 27.8813 25.3133 27.4264 25.1741 27.0142L22.041 17.7309L30.1672 12.1587C30.5286 11.9109 30.6866 11.4566 30.5568 11.038C30.4271 10.6193 30.0399 10.334 29.6016 10.334H19.5781L16.5527 1.0249ZM15.6016 20.084C15.8075 20.084 16.0134 20.1474 16.1884 20.2742L22.2778 24.6868L19.9041 17.6538C19.761 17.2298 19.9171 16.7623 20.2861 16.5093L26.375 12.334H18.8516C18.4184 12.334 18.0345 12.0551 17.9006 11.6431L15.6016 4.56933L15.6016 4.56937V20.084Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c0011dfb4f920b9214e20ecc203cd9c9.svg";
export { ForwardRef as ReactComponent };